import { defineComponent as _defineComponent } from 'vue'
import { inject, Ref, ref } from 'vue';

import {
  Heading,
  Row,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { IPreviewData } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'Preview',
  setup(__props) {

const data = inject('data') as Ref<IPreviewData>;
const isLoading = inject('isLoading') as Ref<boolean>;

const fetchPortfolioSheet = inject('fetchPortfolioSheet', () => ({}));

const rows = ref([
  {
    title: 'Nome do objetivo',
    value: data.value.objectiveName,
    shouldShow: true
  },
  { title: 'Conclusão', value: data.value.period.formatted, shouldShow: true },
  {
    title: 'Perfil de investidor',
    value: data.value.profile?.formatted,
    shouldShow: Boolean(data.value.profile)
  },
  {
    title: 'Nível de risco',
    value: `Nível ${data.value.risk.value}`,
    shouldShow: true
  }
]);

function onClick() {
  fetchPortfolioSheet();
}

return { __sfc: true,data, isLoading, fetchPortfolioSheet, rows, onClick, Heading, Row, ButtonContainer, ButtonPrimary }
}

})